import { PdBoxView } from "./pd-box-view/PdBoxView.js";
//#region src/pd-box-view/pd-box-view.ts
var tag = "pd-box-view";
if (!customElements.get(tag)) customElements.define(tag, PdBoxView);
//#endregion
export { PdBoxView };
